import React, {PureComponent} from 'react'
import {Container, Divider, Grid, Header} from "semantic-ui-react"
import ProjectCard from "../components/ProjectCard"

const p = {
  imgUrl: '/img/student.png',
  title: 'Student Evaluation App',
  ghClientUrl: 'https://github.com/nsch1/evaluation-client',
  ghServerUrl: 'https://github.com/nsch1/evaluation-api',
  shortDesc: 'Individual project at Codaisseur'
}

const p2 = {
  imgUrl: '/img/hangman.png',
  title: 'Hangman Game',
  ghUrl: 'https://github.com/nsch1/hangman-react-redux-homework-2',
  shortDesc: 'Individual assignment in React & Redux'
}

const p3 = {
  imgUrl: '/img/agroxchange.png',
  title: 'AgroXchange',
  ghClientUrl: 'https://github.com/agroXchange/frontend',
  ghServerUrl: 'https://github.com/agroXchange/backend',
  shortDesc: 'Connecting farmers with buyers.'
}

const p4 = {
  imgUrl: '/img/webhooks.png',
  title: 'Webhook Microservice',
  ghUrl: 'https://github.com/Codaisseur15/webhooks-api',
  shortDesc: 'Part of a quiz platform with microservice architecture.'
}

const projects = [p,p2,p3,p4]

export default class ProjectPage extends PureComponent {

  constructor(props) {
    super(props);
    this.state = { width: 0, height: 0 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  renderProjects = () => {
    const width = this.state.width < 768 ? 200 : 300
    return projects.map((p,i) => (
      <Grid.Column key={i} textAlign='center' style={{minWidth:width, marginTop:20}}>
        <ProjectCard project={p} />
      </Grid.Column>
    ))
  }

  render() {
    return (
      <div>
        <Header as='h1' size='huge' inverted>
          Portfolio
        </Header>

        <Divider inverted/>

        <Container textAlign='center'>
          <Grid stackable inverted style={{display: 'inline-block'}}>
            {this.renderProjects()}
          </Grid>
        </Container>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/ProjectPage.js